import React, { useEffect, useState } from "react";
import Toggle from "@atlaskit/toggle";
import Textfield from "@atlaskit/textfield";

const ConvertXMLToJson = ({ action, updateCallback }) => {
  const [enabled, setEnabled] = useState(false);
  const [schemaUrl, setSchemaUrl] = useState("");

  useEffect(() => {
    setEnabled(Boolean(action?.responseOpt?.convertXmlToJson));
    setSchemaUrl(action?.responseOpt?.xsdSchemaUrl || "");
  }, [action]);

  const onToggle = () => {
    if (!action) {
      return;
    }

    const nextValue = !enabled;
    if (!action.responseOpt) {
      action.responseOpt = {};
    }
    action.responseOpt.convertXmlToJson = nextValue;
    setEnabled(nextValue);
    updateCallback?.();
  };

  const onSchemaUrlChange = (event) => {
    const { value } = event.target;
    setSchemaUrl(value);
    if (!action) {
      return;
    }
    if (!action.responseOpt) {
      action.responseOpt = {};
    }
    action.responseOpt.xsdSchemaUrl = value;
    updateCallback?.();
  };

  return (
    <div className="ihub-convert-xml-to-json">
      <div className="ihub-response-file-toggle">
        <Toggle id="convert-xml-to-json-toggle" size="regular" isChecked={enabled} onChange={onToggle} />
        <span style={{ position: "relative", top: "-4px" }}>Convert XML responses to JSON</span>
      </div>
      {enabled && (
        <>
          <p className="ihub-action-tab-description">
            Automatically convert XML responses into JSON so later actions can reference the converted payload.
          </p>
          <p>Convertion will treat every element as an array if no schema was provided</p>
          <div style={{ width: "100%" }}>
            <label htmlFor="xsd-schema-url">
              XSD schema URL <small>(optional)</small>
            </label>
            <Textfield
              isCompact
              id="xsd-schema-url"
              name="xsdSchemaUrl"
              value={schemaUrl}
              onChange={onSchemaUrlChange}
              placeholder="https://example.com/schema.xsd"
            />
            <span className="ihub-action-tab-description">
              Provide a link to the XML Schema Definition if response validation needs to reference it.
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default ConvertXMLToJson;
